/*** IMPORTS FROM imports-loader ***/
var define = false;

import {gsap} from "gsap";
import Swiper from 'swiper-bundle.min';
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";

let imagesLoaded = require('imagesloaded');
gsap.registerPlugin(ScrollTrigger);
"use strict";
console.log('JS loaded');
const navbar = document.querySelector('.navbar');
let target = document.querySelectorAll('.navbar-collapse')[0];
document.addEventListener('DOMContentLoaded', function () {
  console.log('Init Scripts');
  // Mobile toggler
  document.querySelectorAll("button.navbar-toggler")[0].addEventListener("click", function (event) {

    if (!this.classList.contains('open')) {
      $(this).addClass('open');
      $(target).addClass('show');
      $(navbar).addClass('open');
      $('html').addClass('disable-scroll');
    } else {
      $(this).removeClass('open');
      $(target).removeClass('show');
      $(navbar).removeClass('open');
      $('html').removeClass('disable-scroll');
    }
  });

  $('.nav-link').on("click",function (){
    $('button.navbar-toggler').removeClass('open');
    $(target).removeClass('show');
    $(navbar).removeClass('open');
    $('html').removeClass('disable-scroll');
  });

  imagesLoaded(document.querySelector("body"), function (instance) {
    if($( document ).width() >= 1200) {
      gsap.to(".parallax-bg", {
        scrollTrigger: {
          scrub: true
        },
        y: (i, target) => -ScrollTrigger.maxScroll(window) * target.dataset.speed,
        ease: "none"
      });
    }

    // fadein main
    var tlinit = gsap.timeline({
      onComplete: function () {
        console.log('complete');
        $('.loader').hide();
      }
    });

    tlinit.to('.loader', {
      opacity: 0,
      duration: 0.050
    }, '+=0');

    tlinit.to('.navbar', {
      opacity: 1,
      duration: 0.250
    }, '+=0');

    tlinit.to('.banner', {
      opacity: 1,
      duration: 0.250
    }, '+=0.10');
    tlinit.to('main,footer', {
      opacity: 1,
      duration: 0.550
    }, '+=0');

    document.querySelectorAll(".grid-item").forEach((elem) => {
//      const toggle =elem.querySelector('.toggle')
      elem.addEventListener("click", function (event) {
        if(!elem.classList.contains('show'))
          $(".grid-item").removeClass('show')
        elem.classList.toggle('show')
      })
    })

    document.querySelectorAll(".news").forEach((elem) => {
      const toggle =elem.querySelector('.toggle')
      toggle.addEventListener("click", function (event) {
        elem.classList.toggle('show')
      })
    })

    var swiper = new Swiper(".galerie", {
      slidesPerView: "auto",
      spaceBetween: 0,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });
});

window.addEventListener("scroll", function () {
  var nav = document.getElementById("mainNav");
  if (window.scrollY > 100) {
    nav.classList.add("shrink");
  } else {
    nav.classList.remove("shrink");
  }
});

